import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken, LogBack } from '@/utils/auth'
import {
  handleErrors
} from '@/utils/helper/requestHelper'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // 超管切换账号接口使用旧的token
      const token = getToken()
      config.headers['Authorization'] = 'Bearer ' + token
      if (!config.silent) {
        console.log('[请求拦截] URL:', config.url, '| Token:', token ? token.substring(0, 20) + '...' : 'NULL/UNDEFINED')
        if (config.url && config.url.includes('/ai/d/task/')) {
          console.log('[请求拦截] 请求体:', JSON.stringify(config.data))
        }
      }
    } else {
      console.warn('[请求拦截] Vuex token 为空，未设置 Authorization 头 | URL:', config.url)
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    const isSilent = response.config?.silent
    // 调试：记录实际收到的响应和请求头
    if (!isSilent) {
      const reqHeaders = response.config?.headers
      const authSent = reqHeaders?.Authorization || reqHeaders?.authorization || 'NONE'
      console.log('[响应拦截] URL:', response.config?.url, '| Auth发送:', authSent.substring(0, 30) + '...', '| API返回码:', res.code, '| message:', res.message)
    }
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 20000 || res.code === 20010) {
      return res
    }
    // 处理错误状态码
    if (!handleErrors(res, { silent: isSilent })) {
      return
    }
    if (isSilent) {
      // 静默请求：不弹窗、不向上抛错
      return Promise.reject(new Error(res.message || 'Error'))
    }
    Message({
      dangerouslyUseHTMLString: true,
      showClose: true,
      message: res.message.toString() || 'Error',
      type: 'error',
      duration: 2500
    })
    return Promise.reject(new Error(res.message || 'Error'))
  },
  error => {
    // 静默请求：跳过所有 Message 弹窗与控制台日志，直接 reject
    const isSilent = error && error.config && error.config.silent
    const originalRequest = error.config
    if (isSilent) {
      return Promise.reject(error)
    }
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1 && !originalRequest._retry) {
      Message({
        showClose: true,
        message: '请求超时',
        type: 'error',
        duration: 2500
      })
      return Promise.reject(error)
    }
    // 安全访问 response 对象
    const response = error.response
    if (!response) {
      Message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: error.message || '网络异常，请检查网络连接',
        type: 'error',
        duration: 2500
      })
      return Promise.reject(error)
    }
    // 仅在 401 状态码下检查 authorization 头，避免其他错误误触发"登录过期"
    if (response.status === 401 && response.headers && response.headers.authorization) {
      LogBack('您登录已过期，请重新登录')
      console.log('111111', response.headers.authorization, this.rulePath)
    } else if (response.data && response.data.message === 'The token has been blacklisted') {
      LogBack('您登录已过期，请重新登录')
       console.log('222222', response.headers.authorization, this.rulePath)
    } else if (response.status === 401) {
      Message({
        showClose: true,
        message: '请先登录',
        type: 'error',
        duration: 2500
      })
    } else if (response.status === 422) {
      const errorMsg = response.data
      let msg = ''
      const data = errorMsg.errors

      Object.keys(data).forEach(function (key) {
        for (const k in data[key]) {
          msg += data[key][k] + '  '
        }
      })
      Message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: msg,
        type: 'error',
        duration: 2500
      })
    } else {
      Message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: error.message,
        type: 'error',
        duration: 2500
      })
    }
    return Promise.reject(error)
  }
)

export default service
